import { render, staticRenderFns } from "./moneyStatistics.vue?vue&type=template&id=84c726bc&scoped=true&"
import script from "./moneyStatistics.vue?vue&type=script&lang=js&"
export * from "./moneyStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c726bc",
  null
  
)

export default component.exports